var _style, _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMastercard(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 32 20",
    style: {
      enableBackground: "new 0 0 32 20"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, ".st0{clip-path:url(#SVGID_2_);}\n\t.st1{fill:#EFEEEE;}\n\t.st2{fill:none;}\n\t.st3{fillRule:evenodd;clip-rule:evenodd;fill:#CB3F3F;}\n\t.st4{fillRule:evenodd;clip-rule:evenodd;fill:#ED9F2D;}\n\t.st5{fillRule:evenodd;clip-rule:evenodd;fill:#FFFFFF;filter:url(#Adobe_OpacityMaskFilter);}\n\t.st6{mask:url(#mask0_1_);}\n\t.st7{fillRule:evenodd;clip-rule:evenodd;fill:#E5E5E5;fill-opacity:1.000000e-02;}")), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_1_",
    d: "M2,0h28c1.1,0,2,0.9,2,2v16c0,1.1-0.9,2-2,2H2c-1.1,0-2-0.9-2-2V2C0,0.9,0.9,0,2,0z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M0,1.5C0,0.7,0.7,0,1.5,0h29C31.3,0,32,0.7,32,1.5v18c0,0.8-0.7,1.5-1.5,1.5h-29C0.7,21,0,20.3,0,19.5V1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M0,1.5C0,0.7,0.7,0,1.5,0h29C31.3,0,32,0.7,32,1.5v18c0,0.8-0.7,1.5-1.5,1.5h-29C0.7,21,0,20.3,0,19.5V1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M12.5,16c3,0,5.5-2.5,5.5-5.5c0-3-2.5-5.5-5.5-5.5C9.5,5,7,7.5,7,10.5C7,13.5,9.5,16,12.5,16z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M16,14.7c1,0.8,2.2,1.3,3.5,1.3c3,0,5.5-2.5,5.5-5.5c0-3-2.5-5.5-5.5-5.5C18.2,5,17,5.5,16,6.3 c1.2,1,2,2.5,2,4.2C18,12.2,17.2,13.7,16,14.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M16,6.3c-1.2,1-2,2.5-2,4.2c0,1.7,0.8,3.2,2,4.2c1.2-1,2-2.5,2-4.2C18,8.8,17.2,7.3,16,6.3z"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter",
    filterUnits: "userSpaceOnUse",
    x: 13,
    y: 7,
    width: 6,
    height: 9
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
  }))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 13,
    y: 7,
    width: 6,
    height: 9,
    id: "mask0_1_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M16,6.3c-1.2,1-2,2.5-2,4.2c0,1.7,0.8,3.2,2,4.2c1.2-1,2-2.5,2-4.2C18,8.8,17.2,7.3,16,6.3z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st6"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M13,7h6v1h-6V7z M13,9h6v1h-6V9z M19,11h-6v1h6V11z M13,13h6v1h-6V13z M19,15h-6v1h6V15z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M0,1.5C0,0.7,0.7,0,1.5,0h29C31.3,0,32,0.7,32,1.5v18c0,0.8-0.7,1.5-1.5,1.5h-29C0.7,21,0,20.3,0,19.5V1.5z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMastercard);
export default __webpack_public_path__ + "static/media/mastercard.51f78ae46649de2f7b66ab71e3ce7f3a.svg";
export { ForwardRef as ReactComponent };